import { Modal, Button, Group, Text, Image, Box } from "@mantine/core";
import IconX from "@/assets/images/pngs/Group.png";
import React from "react";

interface PopupNotiProps {
  opened: boolean;
  onClose: () => void;
}

const PopupNoti: React.FC<PopupNotiProps> = ({ opened, onClose }) => {
  return (
    <Modal opened={opened} onClose={onClose} ta="center" centered>
      <Box style={{
        display: "flex",
        alignItems:"center",
        justifyContent:"center"
      }}>
        <Image src={IconX} height={80} width={80} fit="contain" />
      </Box>
      <Text fw={900} fz={16} my={15}>
        Thông báo
      </Text>
      <Text fz={14}>
        Số dư tài khoản nguồn của Quý khách không đủ để thực hiện giao dịch. Vui
        lòng chọn tài khoản nguồn khác để tiếp tục.
      </Text>
      <Group position="center" mt={15}>
        <Button
          onClick={onClose}
          sx={() => ({
            width: "100%",
            backgroundColor: "#2A81D0",
            color: "white",
            borderRadius: "8px",
            padding: "8px 10px",
            cursor: "pointer",
            fontWeight: 400,
          })}
        >
          Đóng
        </Button>
      </Group>
    </Modal>
  );
};
export default PopupNoti;
